// extracted by mini-css-extract-plugin
export default {"header-row":"pTRRoJ5VMmTkS39f06Wv","table":"DeBPYk6KmRrvyqCA3Pgm","no-pagination":"NU8E9F6YtxANqveent3m"};